import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserForm from '../UserForm';
import { backToUsers, swapUrlToEdit } from './navigation';
import AdminHeader from './AdminHeader';

const CreateUser = ({ isRestrictedUser, ...props }) => {
  const back = () => backToUsers(props.campaignId, { isRestrictedUser });
  return (
    <>
      <AdminHeader title="Create New User" onBack={back} />
      <UserForm
        {...props}
        screen="create"
        submitLabel="Create"
        showCancel
        showCreateAnother
        onCancel={back}
        onCreated={(user) => swapUrlToEdit(user.id)}
      />
    </>
  );
};

CreateUser.propTypes = { campaignId: PropTypes.string, isRestrictedUser: PropTypes.bool };

const mapStateToProps = (state) => ({ isRestrictedUser: state.AppUser.isRestrictedUser === true });

export default connect(mapStateToProps)(CreateUser);
